export class TreeNode {
  checked: boolean
  isExpanded: boolean
  children: TreeNode[]
  label: string
  value: unknown
  key: string
  parentId: string | null
  id: string

  constructor(
    key: string,
    label: string,
    value = key,
    checked = false,
    node: TreeNode,
  ) {
    for (const key in node) {
      this[key] = node[key]
    }
    this.key = key
    this.value = value
    this.label = label
    this.children = []
    this.isExpanded = false
    this.checked = checked
  }

  get isLeaf() {
    return this.children.length === 0
  }

  get hasChildren() {
    return !this.isLeaf
  }
}

export class Tree {
  root: TreeNode

  constructor(key: string | null, value = key) {
    this.root = new TreeNode(key, value)
  }

  *preOrderTraversal(node = this.root) {
    yield node
    if (node.children.length) {
      for (const child of node.children) {
        yield* this.preOrderTraversal(child)
      }
    }
  }

  insert(
    parentNodeKey: string,
    key: string,
    label: string,
    value = key,
    checked: boolean,
    _node: TreeNode,
  ) {
    for (const node of this.preOrderTraversal()) {
      if (node.key === parentNodeKey) {
        node.children.push(new TreeNode(key, value, label, checked, _node))
        return true
      }
    }
    return false
  }

  collapseAll() {
    for (const node of this.preOrderTraversal()) {
      node.isExpanded = false
    }
    return undefined
  }

  expandAll() {
    for (const node of this.preOrderTraversal()) {
      node.isExpanded = true
    }
    return undefined
  }

  findKey(key: string): TreeNode | undefined {
    for (const node of this.preOrderTraversal()) {
      if (node.key === key) return node
    }
    return undefined
  }

  findFuzzy(value: string): TreeNode[] | undefined {
    const results = []
    for (const node of this.preOrderTraversal()) {
      if (node.label.toLowerCase().includes(value)) results.push(node)
    }
    return results
  }
}
